import React, { useCallback, useState, useMemo } from "react";
import CssBaseline from "@material-ui/core/CssBaseline";
import mergeAdvanced from "object-merge-advanced";
import { MuiThemeProvider, createMuiTheme } from "@material-ui/core/styles";

let defaultTheme = {};

export function addThemeDefault(def) {
  defaultTheme = mergeAdvanced(defaultTheme, def);
}

export function addThemeOverride(def) {
  defaultTheme = mergeAdvanced(def, defaultTheme);
}

export const ThemeContext = React.createContext();

export const {
  Provider: ThemeContextProvider,
  Consumer: ThemeConsumer
} = ThemeContext;

const Themer = ({ theme: initialTheme, children }) => {
  const [initTheme, setInitTheme] = useState(() =>
    mergeAdvanced(defaultTheme, initialTheme)
  );

  const [theme, setMuiTheme] = useState(createMuiTheme(initTheme));

  const setTheme = useCallback(
    t => {
      setInitTheme(t);
      setMuiTheme(createMuiTheme(t));
    },
    [setMuiTheme, setInitTheme]
  );

  const mergeTheme = useCallback(
    t => {
      const merged = mergeAdvanced(initTheme, t);
      setMuiTheme(createMuiTheme(merged));
      return merged;
    },
    [setMuiTheme, initTheme]
  );

  const context = useMemo(
    () => ({
      initialValues: initTheme,
      theme,
      setTheme,
      mergeTheme
    }),
    [theme, setTheme, initTheme, mergeTheme]
  );

  return (
    <ThemeContextProvider value={context}>
      <MuiThemeProvider theme={theme}>
        <CssBaseline>{children}</CssBaseline>
      </MuiThemeProvider>
    </ThemeContextProvider>
  );
};

export default Themer;
